import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { Section7216AcceptanceDialog } from './index'

export default observer(function Inner() {
  const { internal } = useFeatures((app) => ({
    internal: app.account.internal(),
  }))

  const vm = internal.section7216AcceptanceVm

  return (
    <Section7216AcceptanceDialog
      isOpen={vm.modal.showing}
      isLoading={vm.fetchLatest.pending}
      markup={vm.section7216.markup}
      userSignature={vm.userSignature}
      spouseSignature={vm.spouseSignature}
      spouseRequired={vm.isSpouseSignatureRequired}
      userSignatureError={vm.validation.getError('userSignature')}
      spouseSignatureError={vm.validation.getError('spouseSignature')}
      onUserSignatureChange={vm.setUserSignature}
      onSpouseSignatureChange={vm.setSpouseSignature}
      onAccept={vm.accept}
      onDecline={vm.decline}
      isAcceptPending={vm.accept.pending}
    />
  )
})
